import { HttpClient } from '@angular/common/http';
import { MensagemDTO } from '../../models/comunicacao/mensagemDTO';
import { API_CONFIG } from './../../config/api.config';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { FormularioDTO } from 'src/app/models/site/formularioDTO';

@Injectable({
  providedIn: 'root'
})
export class MensagemService {

  constructor(private http: HttpClient){ 
  }

  insert(mensagemDTO: MensagemDTO) : Observable<any> {

    return this.http.post<any>( API_CONFIG.apiURL+'/mensagens'
                              , mensagemDTO
                              , { observe: 'response' });

  }

  


  update(mensagemDTO: MensagemDTO) : Observable<any> {

    
    return this.http.put<any>( API_CONFIG.apiURL+'/mensagens/' + mensagemDTO.id
                             , mensagemDTO
                             , { observe: 'response' });

  }


  findAll() : Observable<MensagemDTO[]> {

    return this.http.get<MensagemDTO[]>( API_CONFIG.apiURL+'/mensagens');

  }

  findByFilter( filtro: string
              , tiposMensagem: string[]
              , idsModalidades: number[]
              , idsFormacoes: number[]
              , idsHabilitacoes: number[]
              , idsCursos: number[]
              , dataEnvioInicial: String
              , dataEnvioFinal: String
              , somenteNaoLidas: boolean
              , page: number
              , pageSize: number
              , sort: string = 'DESC') : Observable<MensagemDTO[]> {

           
    

    return this.http.get<MensagemDTO[]>( API_CONFIG.apiURL+'/mensagens/findByFilter?filtro='+filtro+
                                                                                  '&tiposMensagem='+tiposMensagem+
                                                                                  '&idsCursos='+idsCursos+
                                                                                  '&idsModalidades='+idsModalidades+
                                                                                  '&idsFormacoes='+idsFormacoes+
                                                                                  '&idsHabilitacoes='+idsHabilitacoes+
                                                                                  '&dataEnvioInicial='+dataEnvioInicial+
                                                                                  '&dataEnvioFinal='+dataEnvioFinal+
                                                                                  '&somenteNaoLidas='+somenteNaoLidas+
                                                                                  '&page='+page+
                                                                                  '&size='+pageSize+
                                                                                  '&sort='+sort);

  }

  findByStatus(status: string) : Observable<MensagemDTO[]> {

    return this.http.get<MensagemDTO[]>( API_CONFIG.apiURL+'/mensagens/findByStatus?status='+status);

  }

  find(id: number) : Observable<MensagemDTO> {

    return this.http.get<MensagemDTO>( API_CONFIG.apiURL+'/mensagens/' + id);

  }

  delete(id: number) : Observable<void> {

    return this.http.delete<void>( `${API_CONFIG.apiURL}${'/mensagens/'}${id}`);

  }


  sendFormMessage(formularioDTO: FormularioDTO) : Observable<any> {

    return this.http.post<any>( API_CONFIG.apiURL+'/mensagens/sendFormMessage'
                              , formularioDTO
                              , { observe: 'response' });

  }

  sendEmail(destinatario: string, assunto: string, mensagem: string): Observable<any> {
    
    const emailRequest = {
      destinatario: destinatario,
      assunto: assunto,
      textoMensagem: mensagem
    };

    return this.http.post<any>(
      `${API_CONFIG.apiURL}/mensagens/sendEmailMessage`,
      emailRequest,
      { observe: 'response' }
    );
  }

  sendMessageWithAttachments(
    destinatario: string,
    assunto: string,
    mensagem: string,
    salvarCopiaInterna: boolean,
    urlOrigemMensagem: string,
    anexos: File[]
  ): Observable<any> {
    // Configura os dados do formulário para envio
    const formData = new FormData();
  
    if(salvarCopiaInterna==null){
      salvarCopiaInterna = false;
    }
    const arrDestinatarios = destinatario.split(';')
                                         .map(email => email.trim()) // Remove espaços ao redor
                                         .filter(email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) // Valida formato de email
                                         .join(',');

    if (!arrDestinatarios && !salvarCopiaInterna) {
      console.error('Nenhum email válido encontrado.');
      salvarCopiaInterna = true;
    }

    formData.append('destinatario', arrDestinatarios);
    formData.append('assunto', assunto);
    formData.append('mensagem', mensagem);
    formData.append('salvarCopiaInterna', String(salvarCopiaInterna));
    formData.append('urlOrigemMensagem', String(urlOrigemMensagem));
    
    // Adiciona os arquivos ao FormData
    if (anexos && anexos.length > 0) {
      anexos.forEach((anexo, index) => {
        formData.append(`anexos`, anexo, anexo.name);
      });
    }
  
    // Faz o envio para o endpoint de mensagens com anexos
    return this.http.post<any>(
      `${API_CONFIG.apiURL}/mensagens/sendMessageWithAttachments`,
      formData,
      { observe: 'response' }
    );
  }
  
}
